module.exports = {
      id: "palo-english-usage",
      viewBox: "0 0 230 78",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#palo-english",
      toString: function () {
        return this.url;
      }
    }